import { __decorate, __param } from '../../../../node_modules/tslib/tslib.es6.js';
import { URI } from 'monaco-editor/esm/vs/base/common/uri.js';
import { equals, deepClone } from 'monaco-editor/esm/vs/base/common/objects.js';
import { Emitter } from 'monaco-editor/esm/vs/base/common/event.js';
import { relativePath } from 'monaco-editor/esm/vs/base/common/resources.js';
import { Disposable } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { parse } from 'monaco-editor/esm/vs/base/common/glob.js';
import { IWorkspaceContextService } from 'monaco-editor/esm/vs/platform/workspace/common/workspace.js';
import { IConfigurationService } from 'monaco-editor/esm/vs/platform/configuration/common/configuration.js';
let ResourceGlobMatcher = class ResourceGlobMatcher extends Disposable {
    constructor(globFn, shouldUpdate, contextService, configurationService) {
        super();
        this.globFn = globFn;
        this.shouldUpdate = shouldUpdate;
        this.contextService = contextService;
        this.configurationService = configurationService;
        this._onExpressionChange = this._register(( new Emitter()));
        this.onExpressionChange = this._onExpressionChange.event;
        this.mapRootToParsedExpression = ( new Map());
        this.mapRootToExpressionConfig = ( new Map());
        this.updateExcludes(false);
        this.registerListeners();
    }
    registerListeners() {
        this._register(this.configurationService.onDidChangeConfiguration(e => {
            if (this.shouldUpdate(e)) {
                this.updateExcludes(true);
            }
        }));
        this._register(this.contextService.onDidChangeWorkspaceFolders(() => this.updateExcludes(true)));
    }
    updateExcludes(fromEvent) {
        let changed = false;
        this.contextService.getWorkspace().folders.forEach(folder => {
            const rootExcludes = this.globFn(folder.uri);
            if (!( this.mapRootToExpressionConfig.has(( folder.uri.toString()))) || !equals(this.mapRootToExpressionConfig.get(( folder.uri.toString())), rootExcludes)) {
                changed = true;
                this.mapRootToParsedExpression.set(( folder.uri.toString()), parse(rootExcludes));
                this.mapRootToExpressionConfig.set(( folder.uri.toString()), deepClone(rootExcludes));
            }
        });
        this.mapRootToExpressionConfig.forEach((value, root) => {
            if (root === ResourceGlobMatcher.NO_ROOT) {
                return;
            }
            if (root && !this.contextService.getWorkspaceFolder(( URI.parse(root)))) {
                this.mapRootToParsedExpression.delete(root);
                this.mapRootToExpressionConfig.delete(root);
                changed = true;
            }
        });
        const globalExcludes = this.globFn();
        if (!( this.mapRootToExpressionConfig.has(ResourceGlobMatcher.NO_ROOT)) || !equals(this.mapRootToExpressionConfig.get(ResourceGlobMatcher.NO_ROOT), globalExcludes)) {
            changed = true;
            this.mapRootToParsedExpression.set(ResourceGlobMatcher.NO_ROOT, parse(globalExcludes));
            this.mapRootToExpressionConfig.set(ResourceGlobMatcher.NO_ROOT, deepClone(globalExcludes));
        }
        if (fromEvent && changed) {
            this._onExpressionChange.fire();
        }
    }
    matches(resource, hasSibling) {
        const folder = this.contextService.getWorkspaceFolder(resource);
        let expressionForRoot;
        if (folder && ( this.mapRootToParsedExpression.has(( folder.uri.toString())))) {
            expressionForRoot = this.mapRootToParsedExpression.get(( folder.uri.toString()));
        }
        else {
            expressionForRoot = this.mapRootToParsedExpression.get(ResourceGlobMatcher.NO_ROOT);
        }
        let resourcePathToMatch;
        if (folder) {
            resourcePathToMatch = relativePath(folder.uri, resource);
        }
        else {
            resourcePathToMatch = resource.fsPath;
        }
        return !!expressionForRoot && typeof resourcePathToMatch === 'string' && !!expressionForRoot(resourcePathToMatch, undefined, hasSibling);
    }
};
ResourceGlobMatcher.NO_ROOT = null;
ResourceGlobMatcher = ( __decorate([
    ( __param(2, IWorkspaceContextService)),
    ( __param(3, IConfigurationService))
], ResourceGlobMatcher));
export { ResourceGlobMatcher };
